/**
 * 売上CSV
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/settings/deals`

const setting_deal = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * @return {Promise<unknown>}
     */
    index({ commit }, { keyword, status, trading_start_date, trading_end_date,receivable_type,sales_staff,supplier_id,supplier_type,supplier_name,supplier_location_key,billing_id,billing_name  }) {
      let params = {
        keyword: keyword,
        status: status, 
        trading_start_date: trading_start_date, 
        trading_end_date: trading_end_date, 
        receivable_type: receivable_type, 
        sales_staff: sales_staff,
        supplier_id: supplier_id,
        supplier_type: supplier_type,
        supplier_name: supplier_name,
        supplier_location_key: supplier_location_key,
        billing_id: billing_id,
        billing_name: billing_name,        
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data)
        })
      })
    },
  },
  mutations: {
  },
}

export default setting_deal
